import React from 'react';

const Footer = () => {
    return (
        <footer className="pt-20 pb-10 border-t border-border-light dark:border-border-dark bg-background-light dark:bg-background-dark">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">
                    <div className="text-center md:text-left">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white">Md.Azaharul</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                            Crafting digital experiences with heart & code.
                        </p>
                        <p className="text-xs text-gray-400 dark:text-gray-600 mt-4">
                            © 2023 Md.Azaharul. All rights reserved.
                        </p>
                    </div>
                    <div className="flex gap-4">
                        <a
                            href="https://www.linkedin.com/in/azaharul-islam/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex items-center justify-center text-gray-500 hover:text-primary hover:border-primary transition-colors"
                            aria-label="LinkedIn Profile"
                        >
                            <span className="text-lg font-bold">in</span>
                        </a>
                        <a
                            href="mailto:mdazaharul725@gmail.com"
                            className="w-10 h-10 rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex items-center justify-center text-gray-500 hover:text-primary hover:border-primary transition-colors"
                            aria-label="Email Contact"
                        >
                            <span className="text-lg font-bold">@</span>
                        </a>
                        <a
                            href="https://github.com/Azaharul-islam615"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex items-center justify-center text-gray-500 hover:text-primary hover:border-primary transition-colors"
                            aria-label="GitHub Profile"
                        >
                            <img
                                alt="Github"
                                className="w-5 h-5 dark:invert"
                                src="https://lh3.googleusercontent.com/aida-public/AB6AXuBdrPtiZHq8yn6UTWVf4JaZW143o_TxqI4e1Q3tv0ndfSP5FOa-LxohDrdHRZ5eoRB7oV1XByLruuFpyinkR9ChdRxjTCx9ynBCf8OY5zeHAHMiZ-PrQNUAsAeqLGA-HgnU2-OMBmnW-bZvyQ1fS8rS9TN1DuxozAQ_22F-Kyln-yigm51ECIj4hEwMO11usRd4mdMgNSV7sm4tzBE1HX1lYEWjLN-EuN7zBz03P0fkWIU6ylmNSrRqKuWPR9U3nqeoXcJH2me8bBM"
                            />
                        </a>
                    </div>
                </div>
                <div className="flex justify-between items-center text-[10px] text-gray-400 dark:text-gray-600 mt-12 uppercase tracking-widest">
                    <span>Based in Dhaka, Bangladesh</span>
                    <span>Member of <strong className="text-gray-600 dark:text-gray-400">UWIGARA</strong></span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;